export function recordIdToId(recordId: string): string {
  return recordId.split(":")[1] || recordId;
}
